"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFERRED_HEIGHT = 130;
exports.PLACEHOLDER_COUNT = 3;
//# sourceMappingURL=constants.js.map